import MenuTab from './MenuTab';

export default {
  MenuTab,
};
